<template>
    <h3 :class="{'text-center md:text-left pb-5 md:pb-2.5 m-0':styleBase, 'my-2 md:mb-5':styleCodePage }">
        {{ text }}
    </h3>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true
        },
        styleBase: { // 文字小網置中
            type: Boolean,
            default: false,
        },
        // 變更項目使用 文字靠左
        styleCodePage: {
            type: Boolean,
            default: false,
        },
    }
};
</script>
